import React from 'react';

function PopularService() {
    const services = [
        "One Person Company", "Nidhi Company", "Company Registration", "Tax Notice", 
        "Indian Subsidiary", "HSN Code", "Section 8 Company", "Trademark Search", 
        "USA Company Registration", "FSSAI Registration", "Import Export Code", 
        "ESI Registration", "Proprietorship", "GST Return Filing", "Patta Chitta", 
        "PF Registration", "Payroll", "Business Tax Return Filing", "PF Return Filing", 
        "Eway Bill", "GST Registration", "TDS Filing", "Udyam Registration", 
        "Trademark Registration", "Startup India Registration", "Professional Tax", 
        "Personal Tax Filing", "Check Company or LLP name Availability"
    ];

    return (
        <section className="popular-services-section">
            <div className="container px-4">
                <div className="ps-header">
                    <div className="ps-icon-wrapper">
                        <i className="bi bi-star-fill ps-star-icon"></i>
                    </div>
                    <div>
                        <h3 className="ps-title">Popular Services</h3>
                        <p className="ps-subtitle">Frequently requested by our clients</p>
                    </div>
                </div>
                
                <div className="ps-tags-container">
                    {services.map((service, index) => (
                        <a href="#!" key={index} className="ps-tag-pill">
                            {service}
                        </a>
                    ))}
                </div>
            </div>

            <style dangerouslySetInnerHTML={{
                __html: `
                .popular-services-section {
                    padding: 60px 0;
                    background: #f8fafc;
                    border-top: 1px solid #e2e8f0;
                    font-family: 'Inter', sans-serif;
                }

                .ps-header {
                    display: flex;
                    align-items: center;
                    gap: 15px;
                    margin-bottom: 30px;
                }

                .ps-icon-wrapper {
                    width: 45px;
                    height: 45px;
                    background: #fef3c7;
                    border-radius: 12px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #f59e0b;
                    font-size: 20px;
                    box-shadow: 0 4px 15px rgba(245, 158, 11, 0.15);
                }

                .ps-title {
                    font-size: 24px;
                    font-weight: 800;
                    color: #0f172a;
                    margin: 0 0 4px 0;
                }

                .ps-subtitle {
                    margin: 0;
                    color: #64748b;
                    font-size: 14px;
                    font-weight: 500;
                }

                .ps-tags-container {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 12px;
                }

                .ps-tag-pill {
                    background: #ffffff;
                    border: 1px solid #e2e8f0;
                    color: #334155;
                    padding: 10px 20px;
                    border-radius: 30px;
                    font-size: 13.5px;
                    font-weight: 600;
                    text-decoration: none;
                    transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
                    box-shadow: 0 2px 10px rgba(0,0,0,0.02);
                }

                .ps-tag-pill:hover {
                    background: #115886;
                    border-color: #115886;
                    color: #ffffff;
                    transform: translateY(-3px);
                    box-shadow: 0 8px 20px rgba(17, 88, 134, 0.2);
                }

                @media (max-width: 768px) {
                    .popular-services-section {
                        padding: 40px 0;
                    }
                    .ps-title {
                        font-size: 22px;
                    }
                    .ps-tag-pill {
                        padding: 8px 16px;
                        font-size: 12.5px;
                    }
                }
                `
            }} />
        </section>
    );
}

export default PopularService;